export default "__VITE_ASSET__B7qlJ_HE__"